import { recordIdentifierFor } from '@warp-drive/core';
import type { Observation } from './observation.type.ts';

export interface ObservationExtension extends Observation {}
export class ObservationExtension {
  // ── Computed ──
  // Dasherized resource type of the polymorphic target, e.g. 'account' | 'loan'.
  // In WarpDrive the related record's type is read from its identifier rather
  // than the legacy Model.constructor.modelName.
  get observableType(): string | undefined {
    if (!this.observable) return undefined;
    return recordIdentifierFor(this.observable).type;
  }

  get isStale(): boolean {
    return Boolean(this.staleAfter) && new Date(this.staleAfter as string) <= new Date();
  }
}

const Registration = {
  kind: 'object',
  name: 'observation',
  features: ObservationExtension,
};
export default Registration;
